import {
  setupCache,
  buildStorage,
  StorageValue,
} from "axios-cache-interceptor";
import Axios from "axios";
import localforage from "localforage";

const store = localforage.createInstance({
  name: "SELF_API_CACHED",
});

export const CustomStorage = buildStorage({
  find: async (key) => {
    const items = await store.getItem<string>(`axios-cache:${key}`);
    return items ? (JSON.parse(items) as StorageValue) : undefined;
  },
  set: async (key, value) => {
    await store.setItem(`axios-cache:${key}`, JSON.stringify(value));
  },
  remove: async (key) => {
    await store.removeItem(`axios-cache:${key}`);
  },
});

const CacheService = setupCache(Axios, { storage: CustomStorage });
export default CacheService;
